import * as buds from 'src/js/buds.js';
import { boot } from 'quasar/wrappers'
export default boot(({ app }) =>  {
    app.config.globalProperties.$buds = {...buds}
});